import { IHeNganhTheoDotTuyenSinh } from "./../../reducer-model/category/IDmLoaiThuTuyenSinhReducer";
import {
  IDmLoaiThuTuyenSinh,
  IDmLoaiThuTuyenSinhViewModel,
} from "../../../model/respone/category/IDmLoaiThuTuyenSinh";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eDmLoaiThuTuyenSinhActionsObj = {
  UPDATE_STATUS: {} as eReducerStatusBase,

  LOAD_START: undefined,
  LOAD_SUCCESS: {} as IDmLoaiThuTuyenSinhViewModel[],
  LOAD_ERRR: "",

  SAVE_START: {} as IDmLoaiThuTuyenSinh,
  SAVE_SUCCESS: {} as IDmLoaiThuTuyenSinhViewModel,
  SAVE_ERROR: "",

  SAVE_MULTIPLE_START: {} as IDmLoaiThuTuyenSinh[],
  SAVE_MULTIPLE_SUCCESS: {} as IDmLoaiThuTuyenSinh[],
  SAVE_MULTIPLE_ERROR: "",

  DELETE_START: 0,
  DELETE_SUCCESS: undefined,
  DELETE_ERROR: "",

  CHANGE_REQUEST: {} as any,
  CHANGE_VALUE: {} as any,
  SHOW_EDIT_MODAL: {} as undefined | IDmLoaiThuTuyenSinhViewModel,
  CLOSE_EDIT_MODAL: undefined,

  SELECTED_ID: [] as number[],
  DELETE_MANY_START: [] as number[],
  DELETE_MANY_SUCCESS: undefined,
  DELETE_MANY_ERROR: "",

  LOAD_THEO_DOT_START: 0,
  LOAD_THEO_DOT_SUCCESS: {} as IDmLoaiThuTuyenSinh[],
  LOAD_THEO_DOT_ERRR: "",

  LOAD_HE_NGANH_CHUYEN_NGANH_THEO_DOT_START: 0,
  LOAD_HE_NGANH_CHUYEN_NGANH_THEO_DOT_SUCCESS: {} as IHeNganhTheoDotTuyenSinh[],
  LOAD_HE_NGANH_CHUYEN_NGANH_THEO_DOT_ERRR: "",
};
export const eDmLoaiThuTuyenSinhActionIds = generateActionTypeIds(
  eDmLoaiThuTuyenSinhActionsObj,
  "LOAI_THU_TUYEN_SINH"
);
export type IDmLoaiThuTuyenSinhActionTypes = IGenericActionType<
  typeof eDmLoaiThuTuyenSinhActionsObj,
  "LOAI_THU_TUYEN_SINH"
>;
